module.exports = __webpack_public_path__ + "media/images/flag/en-6caa245ef960abf5c488dbef9a626756.jpg";